export default __webpack_public_path__ + "images/P5.4649493.png";